var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillsPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17975 32.0001H23.9951C25.8311 32.0001 27.3196 30.5117 27.3196 28.6756V1.16699H6.95351V25.738",
    stroke: "black",
    strokeWidth: 1.91907,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40588 25.738H6.95367V29.2263C6.95367 30.7583 5.71177 32.0002 4.17978 32.0002C2.64778 32.0002 1.40588 30.7583 1.40588 29.2263V25.738Z",
    stroke: "black",
    strokeWidth: 1.91907,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0952 27.834H11.2779",
    stroke: "black",
    strokeWidth: 1.91907,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0953 16.1011H11.278V23.9231H23.0953V16.1011Z",
    stroke: "black",
    strokeWidth: 1.91907,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2779 20.012H23.0952",
    stroke: "black",
    strokeWidth: 1.91907,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1172 16.1011V23.9231",
    stroke: "black",
    strokeWidth: 1.91907,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7335 9.49826C19.4956 7.85425 17.1996 6.57218 17.1994 5.46289C17.1996 6.57218 14.8806 7.85374 14.6431 9.49768C14.4057 11.1416 15.8077 12.3302 17.1744 12.3304C18.541 12.3306 19.9561 11.1784 19.7335 9.49826Z",
    stroke: "black",
    strokeWidth: 1.91907,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillsPaymentIcon);
export default __webpack_public_path__ + "static/media/bills-payment-icon.c76610a24b7f605a21ba095993721e64.svg";
export { ForwardRef as ReactComponent };